import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
} from '@/api/alarmanalysisserv'

export default {
  state: {
    state_AlarmAnalysis_GetAllResult: null,
    state_AlarmAnalysis_SearchByNameResult: null,
    state_AlarmAnalysis_GetPageResult: null,
    state_AlarmAnalysis_GetDetailResult: null,
    state_AlarmAnalysis_ModifyObjResult: null,
    state_AlarmAnalysis_DeleteObjResult: null,
  },
  mutations: {
    SET_ALARMANALYSIS_GETALL_RESULT: (state, rst) => {
      state.state_AlarmAnalysis_GetAllResult = rst;
    },
    SET_ALARMANALYSIS_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_AlarmAnalysis_SearchByNameResult = rst;
    },
    SET_ALARMANALYSIS_GETPAGE_RESULT: (state, rst) => {
      state.state_AlarmAnalysis_GetPageResult = rst;
    },
    SET_ALARMANALYSIS_GETDETAIL_RESULT: (state, rst) => {
      state.state_AlarmAnalysis_GetDetailResult = rst;
    },
    SET_ALARMANALYSIS_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_AlarmAnalysis_ModifyObjResult = rst;
    },
    SET_ALARMANALYSIS_DELETEOBJ_RESULT: (state, rst) => {
      state.state_AlarmAnalysis_DeleteObjResult = rst;
    },
  },
  actions: {
    AlarmAnalysisServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALARMANALYSIS_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALARMANALYSIS_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AlarmAnalysisServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALARMANALYSIS_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALARMANALYSIS_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AlarmAnalysisServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALARMANALYSIS_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALARMANALYSIS_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AlarmAnalysisServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALARMANALYSIS_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALARMANALYSIS_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AlarmAnalysisServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALARMANALYSIS_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALARMANALYSIS_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    AlarmAnalysisServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ALARMANALYSIS_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ALARMANALYSIS_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_AlarmAnalysis_GetAllResult: state => {
      return state.state_AlarmAnalysis_GetAllResult;
    },
    get_AlarmAnalysis_SearchByNameResult: state => {
      return state.state_AlarmAnalysis_SearchByNameResult;
    },
    get_AlarmAnalysis_GetPageResult: state => {
      return state.state_AlarmAnalysis_GetPageResult;
    },
    get_AlarmAnalysis_GetDetailResult: state => {
      return state.state_AlarmAnalysis_GetDetailResult;
    },
    get_AlarmAnalysis_ModifyObjResult: state => {
      return state.state_AlarmAnalysis_ModifyObjResult;
    },
    get_AlarmAnalysis_DeleteObjResult: state => {
      return state.state_AlarmAnalysis_DeleteObjResult;
    },
  }
}